import {injectable} from 'inversify';

import type {Expand} from '../../../../api/types';
import type {EnvProviderService} from '../../../system/env/EnvProvider.service';

import {expandObj} from '../../../../api/utils/expand';

@injectable()
export abstract class BaseExpandJrpc {
  constructor(private readonly env: EnvProviderService) {}

  expandObj<T = unknown>(...args: Parameters<typeof expandObj>) {
    return expandObj(...args) as T;
  }

  protected resolve({
    b2b,
    core,
    key,
  }: {
    b2b: Expand;
    core: Expand;
    key?: BaseExpandJrpc.EnvKey;
  }): Expand {
    const resolveKey = key ?? (this.env.app.isB2b ? 'b2b' : 'core');

    const expand = resolveKey === 'b2b' ? b2b : core;

    return expand;
  }
}

export namespace BaseExpandJrpc {
  export type EnvKey = 'b2b' | 'core';
}
